import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import ICustomer from '../../../app/_interfaces/ICustomer';
import IModule from '../../../app/_interfaces/IModule';
import { environment } from '../../../environments/environment';

@Injectable({
  providedIn: 'root',
})
export class ModulesService {
  constructor(private http: HttpClient) {}

  getModules(customer: ICustomer) {
    return this.http.get<IModule[]>(
      `${environment.api.protocol}://${environment.api.host}:${environment.api.port}/api/v1/customers/${customer.id}/modules`
    );
  }
}
